import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { Actions, Types } from '../reducers/Analytics';
import { getAnalytics } from 'services/requests/analytics';
import { Alert } from 'helpers/Alert';

function* getAnalyticsData({ payload }) {
  try {
    const response = yield call(getAnalytics, payload);
    yield put(Actions.getAnalyticsSuccess(response.data));
  } catch (error) {
    console.error('[getAnalytics] failed', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    yield put(Actions.getAnalyticsFailed(error.message));
    Alert({
      type: 'error',
      title: 'Error',
      text: 'Could not load usage data. Please try again.',
    });
  }
}

export function* WatchGetAnalytics() {
  yield takeEvery(Types.GET_ANALYTICS, getAnalyticsData);
}

export default function* analyticsSaga() {
  yield all([fork(WatchGetAnalytics)]);
}
